<template>
  <iframe
    :src="url"
    id="mobsf"
    scrolling="yes"
    frameborder="0"
    style="position:absolute;top:120px;left: 200px;"
  ></iframe>
</template>

<script>
import { baseURL } from "@/service/request.js";
export default {
  data() {
    return {
      url: `${baseURL}/doc.html`
    };
  },
  mounted() {
    /**
     * iframe-宽高自适应显示
     */
    function changeMobsfIframe() {
      const mobsf = document.getElementById("mobsf");
      const deviceWidth = document.body.clientWidth;
      const deviceHeight = document.body.clientHeight;
      mobsf.style.width = Number(deviceWidth) - 200 + "px"; //数字是页面布局宽度差值
      mobsf.style.height = Number(deviceHeight) - 120 + "px"; //数字是页面布局高度差
    }

    changeMobsfIframe();

    window.onresize = function() {
      changeMobsfIframe();
    };
  }
};
</script>
